import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const ExitToApp = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.0206 32.4794L23.9581 35.4169L34.375 25L23.9581 14.5831L21.0206 17.5206L26.3956 22.9163H6.25V27.0831H26.3956L21.0206 32.4794ZM39.5831 6.25H10.4169C9.86963 6.24984 9.32771 6.3575 8.82209 6.56685C8.31646 6.7762 7.85705 7.08312 7.47008 7.47008C7.08312 7.85705 6.7762 8.31646 6.56685 8.82209C6.3575 9.32771 6.24984 9.86963 6.25 10.4169V18.75H10.4169V10.4169H39.5831V39.5831H10.4169V31.25H6.25V39.5831C6.24984 40.1304 6.3575 40.6723 6.56685 41.1779C6.7762 41.6835 7.08312 42.143 7.47008 42.5299C7.85705 42.9169 8.31646 43.2238 8.82209 43.4331C9.32771 43.6425 9.86963 43.7502 10.4169 43.75H39.5831C40.6873 43.7469 41.7453 43.3069 42.5261 42.5261C43.3069 41.7453 43.7469 40.6873 43.75 39.5831V10.4169C43.7469 9.31271 43.3069 8.25467 42.5261 7.47391C41.7453 6.69315 40.6873 6.25313 39.5831 6.25Z"
        fill={color}
      />
    </svg>
  )
}
